import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=b539c4c0&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=b539c4c0&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b539c4c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b539c4c0')) {
      api.createRecord('b539c4c0', component.options)
    } else {
      api.reload('b539c4c0', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=b539c4c0&scoped=true", function () {
      api.rerender('b539c4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/Layout.vue"
export default component.exports